module.exports = __webpack_public_path__ + "img/flag-united-states-desktop.02c5f7d.png";